<template>
  <div style="display: flex; flex-direction: column">
    <div class="btn">
      <el-button type="primary" @click="_modify(null)">新增</el-button>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        style="height: 100%"
      >
        <!-- <el-table-column prop="fid" label="印章ID" /> -->
        <el-table-column prop="fName" label="印章名称" />

        <el-table-column prop="fSqe" label="顺序号" />
        <el-table-column prop="pictureUrl" label="印章图片">
          <template
            scope="scope"
            :style="{ display: display ? 'none' : 'block' }"
          >
            <template v-if="scope.row.pictureUrl">
              <img width="100" height="100" :src="scope.row.pictureUrl">
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <el-button
                type="text"
                size="small"
                @click="_modify(scope.row)"
              >查看</el-button>
            </template>
            <template>
              <ConfirmButton @confirm="_delete(scope.row)">删除</ConfirmButton>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import EditForm from './EditForm'
import AddForm from './AddForm'
import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    EditForm,
    AddForm,
    ConfirmButton
  },
  data() {
    return {
      tableData: [],
      loading: false,
      currentEditItem: null
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('Seal/SealEntry', {})
        .then((res) => {
          // console.log(res, 'res')
          this.tableData = res.datalist
        })
        .finally(() => (this.loading = false))
    },
    _modify(row) {
      const isNew = !row
      if (isNew) {
        this.currentEditItem = {
          fName: null,
          fSqe: null,
          pictureUrl: null
        }
      } else {
        this.currentEditItem = Object.assign({}, row)
      }

      this.$formDlg({
        title: isNew ? '新建印章' : `查看印章`,
        width: '30%',
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(isNew, formData)
      })
    },

    _delete(row) {
      this.loading = true
      this.$httpPost('Seal/DeleteSeal', { fid: row.fid }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.loading = false
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    postData(isNew, data) {
      // console.log(data, 'data')
      return this.$httpPostFile2(
        `Seal/${isNew ? 'Add' : 'Modify'}Seal`,
        {
          datalist: JSON.stringify(data.data)
        },
        { file: data.file }
      ).then(async(res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },

    //    日期格式转换
    dateFormat: function(row, column, cellValue) {
      var date = cellValue
      if (date == undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
